module.exports = __webpack_public_path__ + "static/media/linearRegression.0d86b116.png";